import Vue from 'vue';
import VatsAPI from '../VatsAPI';
import { AxiosResponse } from 'axios';
import { Dictionary } from 'vue-router/types/router';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { UrlOptions, isUrlConfig, getRequestMethod, AcceptsPayload, NoPayload } from './UrlConfig';

function buildEntityComponentMixin<T>() {
    const entityComponentMixin = Vue.extend({
        beforeMount() {
            if (this.loadBeforeMount) {
                this.loadEntity();
            }
        },
        data() {
            return {
                entity: {} as T,
                loading: false,
                validationErrors: {} as Dictionary<string[]>,
                i18nPrefix: '',
                loadBeforeMount: true
            };
        },
        computed: {
            entityUrls(): UrlOptions {
                return '';
            }
        },
        methods: {
            afterSave(response: AxiosResponse<T>): T {
                return response.data;
            },
            afterLoad(response: AxiosResponse<T>): T {
                return response.data;
            },
            async loadEntity() {
                const { method, url } = isUrlConfig(this.entityUrls)
                    ? {
                        method: getRequestMethod<NoPayload<T>>(this.entityUrls.get.urlAction),
                        url: this.entityUrls.get.url
                    }
                    : { method: VatsAPI.get, url: this.entityUrls };
                try {
                    this.loading = true;
                    const response = await method<T>(url);
                    response.data = this.afterLoad(response);

                    this.entity = response.data;
                }
                catch (e) {
                    const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.loadFailedTitle`);
                    const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.loadFailedMessage`);
                    this.$bvToast.toast(translatedMessage.toString(), {
                        title: translatedTitle.toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
                finally {
                    this.loading = false;
                }
            },
            async saveEntity() {
                this.loading = true;
                this.validationErrors = {};

                const { method, url } = isUrlConfig(this.entityUrls)
                    ? {
                        method: getRequestMethod<AcceptsPayload<T>>(this.entityUrls.get.urlAction),
                        url: this.entityUrls.get.url
                    }
                    : { method: VatsAPI.put, url: this.entityUrls };

                try {
                    const response = await method<T>(url, this.entity);
                    response.data = this.afterSave(response);
                    this.entity = response.data;
                }
                catch (e) {
                    this.validationErrors = getValidationErrors(e.response);
                    const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.saveFailedTitle`);
                    const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.saveFailedMessage`);
                    this.$bvToast.toast(translatedMessage.toString(), {
                        title: translatedTitle.toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
                finally {
                    this.loading = false;
                }
            },
            locationChanged() {
                this.loadEntity();
            }
        }
    });

    return entityComponentMixin;
}

export default buildEntityComponentMixin;
